export const TAB_STYLES = [
	{ label: 'Underline', value: 'underline' },
	{ label: 'Pills', value: 'pills' },
	{ label: 'Boxed', value: 'boxed' },
];

export const TAB_ORIENTATIONS = [
	{ label: 'Horizontal', value: 'horizontal' },
	{ label: 'Vertical', value: 'vertical' },
];

export const TAB_POSITIONS = {
	horizontal: [
		{ label: 'Top', value: 'top' },
		{ label: 'Bottom', value: 'bottom' },
	],
	vertical: [
		{ label: 'Left', value: 'left' },
		{ label: 'Right', value: 'right' },
	],
};

export const TAB_ALIGNMENTS = [
	{ label: 'Start', value: 'start' },
	{ label: 'Center', value: 'center' },
	{ label: 'Stretch', value: 'stretch' },
];

const TAB_INNER_TEMPLATE = [
	[
		'core/group',
		{
			style: {
				spacing: {
					padding: {
						top: '20px',
						right: '20px',
						bottom: '20px',
						left: '20px',
					},
				},
			},
			layout: { type: 'constrained', justifyContent: 'left' },
		},
		[
			[ 'core/heading', { level: 3, content: 'Heading' } ],
			[ 'core/paragraph', { content: 'Tab content goes here.' } ],
		],
	],
];

export const TEMPLATE = [
	[ 'brandy/tab', { label: 'Tab 1' }, TAB_INNER_TEMPLATE ],
	[ 'brandy/tab', { label: 'Tab 2' }, TAB_INNER_TEMPLATE ],
	[ 'brandy/tab', { label: 'Tab 3' }, TAB_INNER_TEMPLATE ],
];
